/**
 * @owner @Appboy/core-objects
 */
import { customObjectsTypeNameObjectId } from "../customObjectsTypeNameObjectId/constants";
import type { AllRouteEndpoints } from "../routeTypes";

export const customObjectsTypeName = "/data_objects/:type_name" as const;

/** Invalidate list and item GET caches after create/update mutations on this type. */
export const customObjectsTypeNameCacheKeys: AllRouteEndpoints[] = [
  customObjectsTypeName,
  customObjectsTypeNameObjectId,
];
